import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TreoAnimations } from '@treo/animations';
import { Usuarios } from 'app/models/Usuario/usuarios.model';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../usuarios/usuario.service';



@Component({
    selector: 'app-senha',
    templateUrl: './senha.component.html',
    styleUrls: ['./senha.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: TreoAnimations
})
export class SenhaComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<SenhaComponent>, private usuarioService: UsuarioService, private toastr: ToastrService) { }
    usuario: Usuarios = JSON.parse(localStorage.getItem('usuario'));
    public vendedor: Usuarios = new Usuarios();
    public formulario: FormGroup;
    public span = true;

    ngOnInit(): void {



        this.formulario = new FormGroup({
            nova_senha: new FormControl('', Validators.required),
            nova_senha_dois: new FormControl('', Validators.required)
        });

    }

    fecharDialog() {

        this.dialogRef.close("Fechar");

    }

    salvar(formulario: FormGroup) {

        this.span = false;

        if (formulario.valid) {

            if(formulario.value.nova_senha != formulario.value.nova_senha_dois){
                this.toastr.error(
                    "As senhas não coincidem.",
                    "Alterar senha"
                );
                formulario.enable();
                this.span = true;
                return;
            }

            this.usuario.senha = this.formulario.value.nova_senha;

            this.usuarioService.alterarSenha(this.usuario).subscribe(response => {

                if (response == "Alterou senha") {
                    this.span = true;
                    formulario.enable();
                    this.dialogRef.close(response);
                } else {
                    console.log(response);
                    this.dialogRef.close(response);
                }
            })

        }else {

            this.toastr.error(
                "Por favor, preencha todos os campos.",
                "Dados inválidos"
            );
            formulario.enable();
            this.span = true;
        }

    }

}
